import {Customer} from "../../domain/model/customer";
import {Client} from "../../domain/model/client";
import {Company} from "../../domain/model/company";
import {JobCareer} from "../../domain/model/job_career";
import { PastCaseProject } from "src/domain/model/past_case_project";

// for Client
interface IGetMeClientByClientResponse {
    client?: Client;
    company?: Company;
}
class GetMeClientByClientResponse implements IGetMeClientByClientResponse {
    public client: Client;
    public company: Company;
}

interface IUpdateCompanyByClientResponse {
    company?: Company;
}
class UpdateCompanyByClientResponse implements IUpdateCompanyByClientResponse {
    public company: Company;
}

interface IUpdateClientByClientResponse {
    client?: Client;
}

class UpdateClientByClientResponse implements IUpdateClientByClientResponse {
    public client: Client;
}

interface IUpdatePasswordByClientResponse {
}
class UpdatePasswordByClientResponse implements IUpdatePasswordByClientResponse {
}

interface IUpdateEmailByClientResponse {
}
class UpdateEmailByClientResponse implements IUpdateEmailByClientResponse {
}


// for Customer
interface IGetMeCustomerByCustomerResponse {
    customer?: Customer;
    jobCareers?: JobCareer[];
    pastCaseProjects?: PastCaseProject[];
}
class GetMeCustomerByCustomerResponse implements IGetMeCustomerByCustomerResponse {
    public customer: Customer;
    public jobCareers: JobCareer[];
    public pastCaseProjects: PastCaseProject[];
}

interface IUpdateCustomerByCustomerResponse {
    customer?: Customer;
    jobCareers?: JobCareer[];
    pastCaseProjects?: PastCaseProject[];
}
class UpdateCustomerByCustomerResponse implements IUpdateCustomerByCustomerResponse {
    public customer: Customer;
    public jobCareers: JobCareer[];
    public pastCaseProjects: PastCaseProject[];
}

interface IUpdatePasswordByCustomerResponse {
}
class UpdatePasswordByCustomerResponse implements IUpdatePasswordByCustomerResponse {
}

interface IUpdateEmailByCustomerResponse {
}
class UpdateEmailByCustomerResponse implements IUpdateEmailByCustomerResponse {
}

interface IGenerateCustomerPDFByCustomerResponse {
    blobURL?: string;
}
class GenerateCustomerPDFByCustomerResponse implements IGenerateCustomerPDFByCustomerResponse {
    public blobURL: string;
}

interface IDestroyCustomerPDFByCustomerResponse {
}
class DestroyCustomerPDFByCustomerResponse implements IDestroyCustomerPDFByCustomerResponse {
}

export {
    // client mypage
    GetMeClientByClientResponse,
    UpdateCompanyByClientResponse,
    UpdateClientByClientResponse,
    UpdatePasswordByClientResponse,
    UpdateEmailByClientResponse,
    // customer mypage
    GetMeCustomerByCustomerResponse,
    UpdateCustomerByCustomerResponse,
    UpdatePasswordByCustomerResponse,
    UpdateEmailByCustomerResponse,
    GenerateCustomerPDFByCustomerResponse,
    DestroyCustomerPDFByCustomerResponse,
}



// WEBPACK FOOTER //
// ./src/presentation/response/mypage_response.ts